import { css, keyframes } from 'styled-components'

import { InputType } from 'storybook/internal/types'

export type PulseAnimateMode = 'default' | 'high'

export const PulseAnimateArgTypes = {
  control: 'select',
  options: [false, 'default', 'high']
} as InputType

const pulseAnimateSizes = {
  default: 4,
  high: 8
}

const pulseAnimateKeyframes = (
  size: string,
  color: string | undefined
) => keyframes`
  0% {
    box-shadow: none;
  }

  50% {
    box-shadow: 0 0 0 ${size} ${color}80;
  }

  100% {
    box-shadow: none;
  }
`

export const pulseAnimate = (
  mode: PulseAnimateMode,
  color: string | undefined,
  basePosition: string
) => {
  const size = `${pulseAnimateSizes[mode]}px`

  return css`
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: -${basePosition};
      right: -${basePosition};
      bottom: -${basePosition};
      left: -${basePosition};
      border-radius: inherit;

      animation-name: ${pulseAnimateKeyframes(size, color)};
      animation-duration: 1800ms; // 600ms for wach keyframe item
      animation-timing-function: linear;
      animation-delay: 10ms;
      animation-iteration-count: infinite;
    }
  `
}
